import { render, staticRenderFns } from "./home-unit.vue?vue&type=template&id=0a95f107&scoped=true"
import script from "./home-unit.vue?vue&type=script&lang=js"
export * from "./home-unit.vue?vue&type=script&lang=js"
import style0 from "./home-unit.vue?vue&type=style&index=0&id=0a95f107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95f107",
  null
  
)

export default component.exports